import { Box, Skeleton } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const HeaderCard = styled(Box)`
  ${({ theme }) => css`
    margin-top: 30px;
    padding: 16px 20px;
    border-radius: 12px;
    border: 1px solid #2838971a;
    background: ${theme.colors.gray.light};
  `}
`

export const HeaderTopRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Chip = styled(Skeleton)`
  border-radius: 6px;
`

export const TitleSkeleton = styled(Skeleton)`
  margin-top: 11px;
`

export const SubtitleSkeleton = styled(Skeleton)`
  margin-top: 4px;
`

export const GridCard = styled(Box)`
  ${({ theme }) => css`
    margin-top: 24px;
    padding: 16px 20px;
    border-radius: 12px;
    border: 1px solid ${theme.colors.border.light};
    background: ${theme.colors.lightest};
  `}
`

export const GridRow = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.border.light};
    }
  `}
`

export const GridLabel = styled(Skeleton)``

export const GridValue = styled(Skeleton)``

export const InsertCard = styled(Box)`
  padding: 16px 20px;
  border-radius: 12px;
  background: #2b37970d;
  border: 1px solid #2b37971a;
  margin-top: 24px;
`

export const InsertTopRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`
